import axios from 'axios';
import { useCallback, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import AuthContext, { AuthProvider } from '../contexts/AuthProvider';
import useShowNotification from '../hooks/useShowNotification';

const instance = axios.create();

const AxiosInterceptor = ({ children }) => {
    const { showErrorNotification } = useShowNotification();
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    useEffect(() => {
        // const addAuthorizationHeader = (request) => {
        //     request.headers.authorization = `Bearer ${authContext.auth.token ? authContext.auth.token : ""}`;
        //     return request;
        // }

        // const reqInterceptor = request => {
        //     return addAuthorizationHeader(request);
        // }

        const resInterceptor = response => {
            return response;
        }

        const errInterceptor = error => {
            console.log(error);
            
            if(error.response.status === 401) {
                navigate("/login");
            }

            showErrorNotification(`${error.message}. ${error.response.data}`);

            return Promise.reject(error);
        }

        // const requestInterceptor = instance.interceptors.request.use(reqInterceptor);
        const responseInterceptor = instance.interceptors.response.use(resInterceptor, errInterceptor );

        return () => { 
            instance.interceptors.response.eject(responseInterceptor);
            // instance.interceptors.request.eject(requestInterceptor);
        }
    }, [navigate, showErrorNotification])
    return children;
}


export default instance;
export { AxiosInterceptor }